import { render, staticRenderFns } from "./EquipPointTable.vue?vue&type=template&id=f6eb4982&scoped=true"
import script from "./EquipPointTable.vue?vue&type=script&lang=js"
export * from "./EquipPointTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6eb4982",
  null
  
)

export default component.exports